import React from 'react';
import { Search, Globe, Bot } from 'lucide-react';
export function PlatformSection() {
  return <section id="platform" className="relative bg-[#fafafa] py-32 md:py-40 px-4" data-id="element-72">
      {/* Subtle top gradient transition from dark hero */}
      <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-[#1a1a1a] to-transparent pointer-events-none opacity-30" data-id="element-73" />

      <div className="max-w-7xl mx-auto" data-id="element-74">
        <div className="mb-24" data-id="element-75">
          <p className="text-lg font-bold uppercase tracking-widest text-[#1e3a5f] mb-4" data-id="element-76">
            The Challenge
          </p>
          <h2 className="text-4xl md:text-6xl text-[#1a1a1a] font-light mb-6" data-id="element-77">
            Global trade is{' '}
            <span className="font-semibold text-[#1e3a5f]" data-id="element-78">changing</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-79">
          {/* Subsection 1 */}
          <div className="space-y-8" data-id="element-80">
            <h3 className="text-2xl md:text-3xl text-[#1a1a1a] leading-tight" data-id="element-81">
              Consumers can increasingly find the products they want from across
              the full range of global supply.
            </h3>

            <ul className="space-y-6 mt-8" data-id="element-82">
              {[{
              icon: Search,
              text: 'Search'
            }, {
              icon: Globe,
              text: 'Online Marketplaces'
            }, {
              icon: Bot,
              text: 'Agentic Commerce'
            }].map((item, i) => <li key={i} className="flex items-center space-x-4 p-4 bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-83">
                  <div className="bg-[#f0f5f9] p-2 rounded-lg text-[#1e3a5f]" data-id="element-84">
                    <item.icon size={20} data-id="element-85" />
                  </div>
                  <span className="text-lg font-medium text-[#1a1a1a]" data-id="element-86">
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Subsection 2 */}
          <div className="space-y-8" data-id="element-87">
            <h3 className="text-2xl md:text-3xl text-[#1a1a1a] leading-tight" data-id="element-88">
              Distribution is{' '}
              <span className="font-semibold text-[#1e3a5f]" data-id="element-89">inefficient</span>.
            </h3>

            <div className="space-y-6 text-gray-600 text-lg leading-relaxed" data-id="element-90">
              <p data-id="element-91">
                Wholesalers serve manufacturers both by holding inventory and
                marketing their products to their networks of wholesaler
                customers.
              </p>
              <p data-id="element-92">
                But every layer in the supply chain adds shipping and warehouse
                logistics costs.
              </p>
              <p data-id="element-93">
                As consumers increasingly find the goods they want online,
                wholesalers marketing products to their network of wholesalers
                becomes irrelevant.
              </p>
              <p className="font-medium text-[#1a1a1a]" data-id="element-94">
                The many layers in the supply chain become unnecessary.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}